export default __webpack_public_path__ + "static/proxima-nova-400-6c824a56f07c0467cbd6348b9bbcebd6.woff2";